module.exports = __webpack_public_path__ + "media/images/emblems/Hauterive-FR-coat_of_arms-7670822c444c59785b8fac44e68c72c9.svg";